import React, {useEffect, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {
    Box,
    Dialog,
    IconButton,
    Slide,
    Theme,
    Toolbar,
    Paper,
    Typography,
    Card,
    CardContent,
    CardHeader,
    CardActions,
    Tabs,
    Tab,
    LinearProgress
} from "@mui/material";
import {CloseRounded} from "@mui/icons-material";
import {useTheme} from '@mui/material/styles';
import {useParams} from "react-router-dom";
import {ContainerClasses} from '../../themes/containerClasses'
import {retrieveRecord,
        updateRecord,
        deleteRecord as deleteRecordApi,
        selectError,
        selectRecord,
        selectSelectedLayout,
        selectLayouts,
        selectActions,
        selectObjectMetadata,
        selectIsFetching as selectIsFetchingRecord} from "./recordSlice";
import MonitorIcon from '@mui/icons-material/Monitor';
import ArrowRightAltIcon from '@mui/icons-material/ArrowRightAlt';
import {ErrorComponent} from "../../components/error/Error";
import {LayoutSelectorComponent} from "../../components/layoutSelector/LayoutSelector";
import {RecordTabPanelComponent} from "../../components/recordTabPanel/RecordTabPanel";
import {ActionsComponent} from "../../components/actions-r/Actions"
import {LayoutTabModel,
        LayoutModel,
        LayoutFieldModel,
        RecordModel} from "../../models/models";
import {useSnackbar} from "notistack";
import {setSelectedTabObject} from "../../app/globalLayoutSlice";
import { useNavigate } from "react-router";
import {getAppName, getObjectName, getRecordUuid } from "../../utils/helperRouter";
import { useAuth } from "../../hooks/useAuth";
import {checkLayoutFieldRequirement,
        getFieldError} from '../../utils/fieldValidations';
import { ObjectAvatar } from "../../components/icons/ObjectAvatar";

export const RecordScreen = () => {

  let {appName, objectName, recordUuid} = useParams();

  const theme = useTheme();
  const styles = ContainerClasses();
  const { accessToken, onInvalidToken } = useAuth();

  const dispatch = useDispatch<any>();
  const { enqueueSnackbar } = useSnackbar();
  const navigate = useNavigate();

//  const authToken = useSelector(selectAuthenticationToken);
  const fetchError = useSelector(selectError);
  const record = useSelector(selectRecord);
  const selectedLayout = useSelector(selectSelectedLayout);
  const availableLayouts = useSelector(selectLayouts);
  const availableActions = useSelector(selectActions);
  const objectMetadata = useSelector(selectObjectMetadata);
  const isFetchingRecord = useSelector(selectIsFetchingRecord);


  const [selectedTab, setSelectedTab] = useState<LayoutTabModel | null>(null);


  const handleChangeTab = (event: any, newValue: string) => {
    const thisTab = selectedLayout?.layout_tabs.find((element) => element.Uuid_sys === newValue);
    setSelectedTab(thisTab !== undefined ? thisTab : null);
  }

  useEffect(() => {
      const thisAppName = getAppName(appName)
      const thisObjectName = getObjectName(objectName)
      const thisRecordUuid = getRecordUuid(recordUuid)
      dispatch(retrieveRecord(thisObjectName, thisRecordUuid, null, accessToken, false, onInvalidToken));
      dispatch(setSelectedTabObject(thisObjectName));
  }, [appName, objectName, recordUuid]); // eslint-disable-line react-hooks/exhaustive-deps


  useEffect(() => {
      if(selectedLayout !== null &&
         selectedLayout.layout_tabs.length > 0 &&
         selectedLayout.layout_tabs[0]){
           setSelectedTab(selectedLayout.layout_tabs[0])
         }
  }, [selectedLayout?.layout_tabs.length]); // eslint-disable-line react-hooks/exhaustive-deps


  const selectLayout = (thisLayout: LayoutModel) => {
      const thisObjectName = getObjectName(objectName)
      const thisRecordUuid = getRecordUuid(recordUuid)
      dispatch(retrieveRecord(thisObjectName, thisRecordUuid, thisLayout.ApiName_sys, accessToken, true, onInvalidToken));
  }




  const isLoading = isFetchingRecord;


  const saveChanges = async(updatedRecord: RecordModel) => {
    const thisObjectName = getObjectName(objectName)
    const thisRecordUuid = getRecordUuid(recordUuid)

/*
    const allErrors = selectedTab?.layout_sections.map((thisSection) => {
      //check all sections for errors
      const allErrors = thisSection.layout_fields.map((thisLayoutField) => {
        //check all fields in this section for errors
        const fieldApiName = thisLayoutField.ReferencedField_sys.ApiName_sys;
        const thisField = updatedRecord.fields[fieldApiName];
        const thisError = getFieldError(thisField, thisLayoutField);
        return thisError

      })
      const thisError = allErrors.includes(true);
      return thisError
    })
    const thisError = allErrors?.includes(true);

    if(thisError === true){
      enqueueSnackbar("Error: some required fields are not defined or not properly validated", {
          variant: "error",
      });
      return
    }
*/
    const allErrors: LayoutFieldModel[] = [];
    selectedTab?.layout_sections.forEach((thisSection) => {
      //check all sections for errors
      thisSection.layout_fields.forEach((thisLayoutField) => {
        //check all fields in this section for errors
        const fieldApiName = thisLayoutField.ReferencedField_sys.ApiName_sys;
        const thisField = updatedRecord?.fields[fieldApiName];
        const thisError = getFieldError(thisField, thisLayoutField);
        if(thisError) allErrors.push(thisLayoutField)
      })
    })

    if(allErrors.length >= 1){
      enqueueSnackbar(
        <Box>
          <Typography>
            Error: some fields are not defined or not properly validated
          </Typography>
          <Box sx={{display: 'flex', flexDirection: 'column', gap: 0.5}}>
          {allErrors.map((error, index) => (
            <Typography
              key={index}
              sx={{textAlign: 'left', pl: 3}}
            >
              {error.ReferencedField_sys.Label_sys}
            </Typography>
          ))}
          </Box>
        </Box>,
        {
          variant: "error",
        }
      );
      return
    }


    const message = await dispatch(updateRecord(thisObjectName, thisRecordUuid, updatedRecord, accessToken));
    if(message === 'success'){
       enqueueSnackbar("The record has been updated successfully.", {
               variant: "success",
          });
    } else{
       enqueueSnackbar(message, {
               variant: "error",
          });
    }
  };

  const deleteRecord = async (thisRecord: RecordModel) => {
    const thisAppName = getAppName(appName)
    const thisObjectName = getObjectName(objectName)
    const thisRecordUuid = getRecordUuid(recordUuid)
//    const message: string = "success";

    const message = await dispatch(deleteRecordApi(thisObjectName, thisRecordUuid, accessToken));
    if(message === 'success'){
       enqueueSnackbar("The record has been deleted successfully.", {
               variant: "success",
          });
        navigate(`/${thisAppName}/${thisObjectName}`);

    } else{
       enqueueSnackbar(message, {
               variant: "error",
          });
    }
  };


/*


  const deleteRoomBooking = async(bookedSlot: BookedSlot) => {
    const message = await dispatch(deleteBookedSlot(authToken, bookedSlot, thisCustomer));
    if(message === 'success'){
       //update customer
       const currentCosts = getCurrentCostsB([bookedSlot]);
       setThisCustomer({...thisCustomer,
                         creditBalance: thisCustomer.creditBalance + currentCosts})
       enqueueSnackbar("The meeting has been deleted successfully.", {
               variant: "success",
          });
    } else{
       enqueueSnackbar(message, {
               variant: "error",
          });
    }
  }
*/




  return (
     <Box>
       {isLoading && <LinearProgress color="primary" />}
       {fetchError !== null &&
           <ErrorComponent
              errorMessage = {fetchError}
           />
       }

       {fetchError === null &&
        <Card
           sx={styles.containerCard}>
           <Box sx={styles.containerRowB}>
              <Box>
                {objectMetadata &&
                  <ObjectAvatar
                     objectMetadata={objectMetadata}
                     size={36}
                />
                }

                <LayoutSelectorComponent
                   selectedLayout = {selectedLayout}
                   availableLayouts = {availableLayouts}
                   selectLayout = {selectLayout}
                />
              </Box>

              <CardActions>
                 <ActionsComponent
                    availableActions = {availableActions}
                 />
              </CardActions>

           </Box>

           <CardContent>
              <Tabs
                 value={selectedTab !== null ? selectedTab.Uuid_sys : false}
                 onChange={(event, newValue) => handleChangeTab(event, newValue)}>

                 {selectedLayout?.layout_tabs.map((layout_tab) => {
                   return (
                    <Tab
                       key={layout_tab.Uuid_sys}
                       value={layout_tab.Uuid_sys}
                       label={layout_tab.Label_sys}
                    />
                  )}
                )}
              </Tabs>

              {selectedTab &&
               record &&
                <RecordTabPanelComponent
                   layoutTab = {selectedTab}
                   record = {record}
                   saveChanges = {saveChanges}
                   deleteRecord = {deleteRecord}
                />
              }

           </CardContent>
        </Card>
      }
     </Box>

);
};
